// config.js
export const COUNTRIES = {
  US: {
	code: 'US',
	name: 'United States',
	flag: '🇺🇸',
	govDomains: ['.gov'],
	defaultLanguage: 'en',
	hashtags: ['government', 'politics', 'govstr']
  },
  MX: {
	code: 'MX',
	name: 'México',
	flag: '🇲🇽',
	govDomains: ['.gob.mx'],
	defaultLanguage: 'es',
	hashtags: ['gobierno', 'politica', 'gobmx', 'govstr']
  },
  BR: {
	code: 'BR',
	name: 'Brasil',
	flag: '🇧🇷',
	govDomains: ['.gov.br'],
	defaultLanguage: 'pt',
	hashtags: ['governo', 'politica', 'govbr', 'govstr']
  },
  CA: {
	code: 'CA',
	name: 'Canada',
	flag: '🇨🇦',
	govDomains: ['.gc.ca', '.canada.ca'],
	defaultLanguage: 'en',
	hashtags: ['cdnpoli', 'canpoli', 'govcan', 'govstr']
  },
  UK: {
	code: 'UK',
	name: 'United Kingdom',
	flag: '🇬🇧',
	govDomains: ['.gov.uk'],
	defaultLanguage: 'en',
	hashtags: ['ukpolitics', 'ukgov', 'govuk', 'govstr']
  },
  DE: {
	code: 'DE',
	name: 'Deutschland',
	flag: '🇩🇪',
	govDomains: ['.bund.de', '.bayern.de', '.berlin.de', '.brandenburg.de', '.bremen.de', 
				 '.hamburg.de', '.hessen.de', '.mv.de', '.niedersachsen.de', '.nrw.de', 
				 '.rlp.de', '.saarland.de', '.sachsen.de', '.sachsen-anhalt.de', 
				 '.schleswig-holstein.de', '.thueringen.de'],
	defaultLanguage: 'de',
	hashtags: ['bundestag', 'politik', 'bundesregierung', 'govstr']
  }
};

export const LANGUAGES = {
  en: {
	code: 'en',
	name: 'English',
	translations: {
	  search: 'Search posts...',
	  loading: 'Loading posts...',
	  noResults: 'No matching posts found.',
	  foundPosts: 'Found {count} matching posts',
	  settings: 'Settings',
	  feed: 'Feed',
	  language: 'Language',
	  country: 'Country',
	  govLinks: 'Government Links',
	  hideReplies: 'Hide replies',
	  showReplies: 'Show replies ({count})'
	}
  },
  es: {
	code: 'es',
	name: 'Español',
	translations: {
	  search: 'Buscar publicaciones...',
	  loading: 'Cargando publicaciones...',
	  noResults: 'No se encontraron publicaciones.',
	  foundPosts: 'Se encontraron {count} publicaciones',
	  settings: 'Configuración',
	  feed: 'Publicaciones',
	  language: 'Idioma',
	  country: 'País',
	  govLinks: 'Enlaces Gubernamentales',
	  hideReplies: 'Ocultar respuestas',
	  showReplies: 'Mostrar respuestas ({count})'
	}
  },
  pt: {
	code: 'pt',
	name: 'Português',
	translations: {
	  search: 'Pesquisar posts...',
	  loading: 'Carregando posts...',
	  noResults: 'Nenhum post encontrado.',
	  foundPosts: 'Encontrados {count} posts',
	  settings: 'Configurações',
	  feed: 'Feed',
	  language: 'Idioma',
	  country: 'País',
	  govLinks: 'Links Governamentais',
	  hideReplies: 'Ocultar respostas',
	  showReplies: 'Mostrar respostas ({count})'
	}
  },
  de: {
	code: 'de',
	name: 'Deutsch',
	translations: {
	  search: 'Beiträge suchen...',
	  loading: 'Beiträge werden geladen...',
	  noResults: 'Keine Beiträge gefunden.',
	  foundPosts: '{count} Beiträge gefunden',
	  settings: 'Einstellungen',
	  feed: 'Feed',
	  language: 'Sprache',
	  country: 'Land',
	  govLinks: 'Regierungslinks',
	  hideReplies: 'Antworten ausblenden',
	  showReplies: 'Antworten anzeigen ({count})'
	}
  },
  fr: {
	code: 'fr',
	name: 'Français',
	translations: {
	  search: 'Rechercher des publications...',
	  loading: 'Chargement des publications...',
	  noResults: 'Aucune publication trouvée.',
	  foundPosts: '{count} publications trouvées',
	  settings: 'Paramètres',
	  feed: 'Fil',
	  language: 'Langue',
	  country: 'Pays',
	  govLinks: 'Liens gouvernementaux',
	  hideReplies: 'Masquer les réponses',
	  showReplies: 'Afficher les réponses ({count})'
	}
  }
};